import React, { useMemo } from 'react';

import { SingleQuestionController } from '@sm/question-widgets/respondent-survey';
import { ExternalQuestion } from '@sm/question-definitions';
import groupQuestionsWithLayoutConfig from './utils';
import { QuestionRowLayout } from '../QuestionRowLayout';
import { AnswerObject } from '../../CurrentPageContext';

export type Props = {
  questions: ExternalQuestion[];
  answers: AnswerObject;
};

function QuestionListController({ questions, answers }: Props): React.ReactElement {
  const groups = useMemo(() => groupQuestionsWithLayoutConfig(questions), [questions]);
  return (
    <>
      {groups.map(group => (
        <QuestionRowLayout key={`group_${group.map(g => g.id).concat('-')}`}>
          {group.map(question => (
            <SingleQuestionController
              key={question.id}
              {...{ question }}
              displayOptions={{ answer: answers[question.id] }}
            />
          ))}
        </QuestionRowLayout>
      ))}
    </>
  );
}

export default QuestionListController;
